import { clear } from "console"
import { observable } from "mobx"
import Constants from "../../common/constants/Constants"
import HttpStatusCode from "../../common/constants/HttpErrorCode"
import { realtimeEvent } from "../../common/eventsource/RealtimeEvent"
import { getRequest } from "../../common/helpers/RequestHelper"
import { IEpsStockInfo, IShortCompanyInfo, IStockInfo, IStockSymbol, REGISTER_SOCKET_TYPE, STOCK_BG_COLOR_CONIG, TopType } from "../../common/model/Model"
import { appStore } from "../../common/store/AppStore"
import _ from 'lodash'
class TopStockStore {
    @observable topUpDownStockInfo?: IStockSymbol[]
    @observable searchSymbol: string = ""
    stockSymbols: string[] = []
    @observable listShortCompanyInfo: IShortCompanyInfo[] = []
    @observable showSearchForm = false
    async getListCompanyShortInfo() {
        topStockStore.listShortCompanyInfo = appStore.listShortCompany
    }
    async getTopUpStockInfo(topType?: string, indexSymbol?: string, top?: number) {
        this.topUpDownStockInfo = undefined
        let api = ""
        if (topType === TopType.Overview) {
            api = "GetTopUpStockInfo_Overview"
        }
        else if (topType === TopType.Change) {
            api = "GetTopUpStockInfo_Change"
        }
        else if (topType === TopType.Finance) {
            api = "GetTopUpStockInfo_Finance"
        }
        let result = await getRequest(Constants.API_DASHBOARD_URL + api + '?indexSymbol=' + indexSymbol + '&top=' + top)
        if (result.status < HttpStatusCode.CODE_300) {
            this.topUpDownStockInfo = result.body
            this.stockSymbols = []
            result.body.map((item) => {
                this.stockSymbols.push(item.stockSymbol)
            })
            this.regisListenStockSymbolUpdate()
        }
    }
    async getTopDownStockInfo(topType?: string, indexSymbol?: string, top?: number) {
        this.topUpDownStockInfo = undefined
        let api = ""
        if (topType === TopType.Overview) {
            api = "GetTopDownStockInfo_Overview"
        }
        else if (topType === TopType.Change) {
            api = "GetTopDownStockInfo_Change"
        }
        else if (topType === TopType.Finance) {
            api = "GetTopDownStockInfo_Finance"
        }
        let result = await getRequest(Constants.API_DASHBOARD_URL + api + '?indexSymbol=' + indexSymbol + '&top=' + top)
        if (result.status < HttpStatusCode.CODE_300) {
            this.topUpDownStockInfo = result.body
            this.stockSymbols = []
            result.body.map((item) => {
                this.stockSymbols.push(item.stockSymbol)
            })
            this.regisListenStockSymbolUpdate()
        }
    }
    async getEpsStocInfo(indexSymbol?: string, top?: number) {
        this.topUpDownStockInfo = undefined
        const result = await getRequest(Constants.API_DASHBOARD_URL + 'GetTopEps?indexSymbol=' + indexSymbol + '&top=' + top)
        if (result.status < HttpStatusCode.CODE_300) {
            this.topUpDownStockInfo = result.body
            this.stockSymbols = []
            result.body.map((item) => {
                this.stockSymbols.push(item.stockSymbol)
            })
            this.regisListenStockSymbolUpdate()
        }
    }
    async regisListenStockSymbolUpdate() {
        appStore.regisShortStockInfo()
    }

    updateStockSymbol(data: IStockSymbol[]) {
        if (this.topUpDownStockInfo) {
            this.topUpDownStockInfo.map((currentStock, index) => {
                let newStock = data.find((index) => (index.stockSymbol === currentStock.stockSymbol))
                if (newStock && this.topUpDownStockInfo) {
                    let t: IStockSymbol = _.cloneDeep(newStock);
                    t.pctPrice = currentStock.pctPrice
                    t.marketCap = currentStock.marketCap
                    t.pe = currentStock.pe;
                    t.pb = currentStock.pb;
                    t.beta = currentStock.pb
                    t.pctPrice1Day = currentStock.pctPrice1Day
                    t.pctPrice1Month = currentStock.pctPrice1Month
                    t.pctPrice1Week = currentStock.pctPrice1Week
                    t.pctPrice1Year = currentStock.pctPrice1Year
                    t.pctPrice2Weeks = currentStock.pctPrice2Weeks
                    t.pctPrice3Months = currentStock.pctPrice3Months
                    t.pctPrice6Months = currentStock.pctPrice6Months
                    t.pctPrice9Months = currentStock.pctPrice9Months
                    t.pctPriceUptoNow = currentStock.pctPriceUptoNow
                    t.bvps = currentStock.bvps
                    t.ebit = currentStock.ebit
                    t.eps = currentStock.eps
                    t.industryName = currentStock.industryName
                    t.interest = currentStock.interest
                    t.revenue = currentStock.revenue
                    t.yearReport = currentStock.yearReport
                    t.profit = currentStock.profit
                    t.previousYear = currentStock.previousYear
                    t.previousRevenue = currentStock.previousRevenue
                    t.previousProfit = currentStock.previousProfit
                    t.changeProfit = currentStock.changeProfit
                    if (currentStock.matchPrice && t.matchPrice && currentStock.matchPrice < t.matchPrice) {
                        t.colorUpdate = STOCK_BG_COLOR_CONIG.UP
                    }
                    if (currentStock.matchPrice && t.matchPrice && currentStock.matchPrice > t.matchPrice) {
                        t.colorUpdate = STOCK_BG_COLOR_CONIG.DOWN
                    }
                    if (currentStock.basicPrice) {
                        if (currentStock.matchPrice !== t.matchPrice) {
                            this.topUpDownStockInfo[index] = t
                            this.topUpDownStockInfo[index].isUpdate = true;
                            setTimeout(() => {
                                if (this.topUpDownStockInfo)
                                    this.topUpDownStockInfo[index].colorUpdate = ""
                            }, Constants.EFFECT_UPDATE_TIME)
                            this.topUpDownStockInfo[index] = t
                        }
                    }
                    else {
                        this.topUpDownStockInfo[index] = t
                        this.topUpDownStockInfo[index].isUpdate = true;
                        setTimeout(() => {
                            if (this.topUpDownStockInfo)
                                this.topUpDownStockInfo[index].colorUpdate = ""
                        }, Constants.EFFECT_UPDATE_TIME)
                        this.topUpDownStockInfo[index] = t
                    }
                    this.topUpDownStockInfo[index].priceChangePercent=t.priceChangePercent;

                }
            })
        }
    }
    async handleSymbolStockSelect(symbol: string) {
        topStockStore.showSearchForm = false
        topStockStore.searchSymbol = ""
        const result = await getRequest(Constants.API_DASHBOARD_URL + 'CashFlowTrGetTopEPSForStockSymbolending?stockSymbol=' + symbol)
        if (result.status < HttpStatusCode.CODE_300) {
            topStockStore.topUpDownStockInfo = result.body
            topStockStore.stockSymbols = []
            result.body.map((item) => {
                topStockStore.stockSymbols.push(item.stockSymbol)
            })
            topStockStore.regisListenStockSymbolUpdate()
        }
    }
    async handleChageInputSearch(key: string) {
        topStockStore.searchSymbol = key
        if (key) {
            topStockStore.showSearchForm = true
            topStockStore.listShortCompanyInfo.map((item) => {
                if (item.value.toUpperCase().indexOf(key.toUpperCase()) > -1) {
                    item.isHide = false
                }
                else item.isHide = true
            })
            let t = _.cloneDeep(topStockStore.listShortCompanyInfo)
            t.sort((a, b) => {
                if (a.value.toLowerCase().indexOf(key.toLowerCase()) > b.value.toLowerCase().indexOf(key.toLowerCase())) {
                    return 1;
                } else if (a.value.toLowerCase().indexOf(key.toLowerCase()) < b.value.toLowerCase().indexOf(key.toLowerCase())) {
                    return -1;
                } else {
                    if (a.value > b.value)
                        return 1;
                    else
                        return -1;
                }
            });
            topStockStore.listShortCompanyInfo = t
        }
        else {
            topStockStore.showSearchForm = false
        }
    }

}
export const topStockStore = new TopStockStore()